import { trackedWeakSet } from '@ember/reactive/collections';
import Service, { service } from '@ember/service';

export default class RecordStatusService extends Service {
  // Dependencies
  @service recordLocks;

  // Status
  isBlocked(record) {
    return Boolean(record && 'cmsState' in record && record.cmsState === 6);
  }

  isDisabled(record) {
    return Boolean(
      this.isBlocked(record) ||
      this.recordLocks.isLocked(record) ||
      this.recordLocks.isLocking(record) ||
      this.isPublishing(record) ||
      record?.isSaving ||
      (this.hasValidations(record) && record.validations.isValidating),
    );
  }

  isDisabledOrInvalid(record) {
    return Boolean(
      this.isDisabled(record) ||
      (this.hasValidations(record) && record.validations.isInvalid),
    );
  }

  hasValidations(record) {
    return Boolean(
      isRecord(record) && 'validations' in record && record.validations,
    );
  }

  // Publishing
  publishingRecords = trackedWeakSet();

  isPublishing(record) {
    return isRecord(record) && this.publishingRecords.has(record);
  }

  setPublishing(record, isPublishing) {
    if (!isRecord(record)) {
      return;
    }

    if (isPublishing) {
      this.publishingRecords.add(record);
    } else {
      this.publishingRecords.delete(record);
    }
  }
}

function isRecord(record) {
  return Boolean(record && typeof record === 'object');
}
